import { Component, OnInit, Input } from '@angular/core';
import { InvoiceService } from '../../invoices/invoice.service';
import { PayService } from '../../invoices/pay.service';


@Component({
  selector: 'sales-collection-form',
  templateUrl: './sales-collection-form.component.html',
})
export class SalesCollectionForm implements OnInit {

  payModel:any = {}

  constructor( private payService:PayService ,
   
  ) { }

  ngOnInit() { }

  close() {
    
  }

  submitSaleCollectionForm(scfData) {
    /*
    send to service for invoice pay service
    */

    //this.payService.submitSCFData(scfData)




  }




}
